import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

// Pages and Components
import Home from "./pages/Home";
import Catalog from "./components/Catalog";
import ProductDetails from "./pages/ProductDetail";
import Footer from "./components/Footer";

import "./App.css";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Home route with AboutUs and Catalog */}
          <Route
            path="/"
            element={
              <>
                <Home />
              </>
            }
          />

          {/* Product Details Page (no AboutUs here) */}
          <Route path="/product/:id" element={<ProductDetails />} />

          {/* Catalog as a standalone page (optional) */}
          <Route path="/catalog" element={<Catalog />} />
        </Routes>

        {/* Footer appears on all pages */}
        <Footer />
      </div>
    </Router>
  );
}

export default App;
